import React from 'react';
import PropTypes from 'prop-types';

export default function MonzoFull({ size }) {
  return (
    <svg width={size} height="28" viewBox="0 0 118.33 28.69">
      <path
        d="M32.28,21.6a1.5,1.5,0,0,1-.43,1l-6.66,6.59a.59.59,0,0,1-1-.41V14l8-7.89h.09V21.6"
        transform="translate(-0.18 -0.71)"
        style={{ fill: '#e83860' }}
      />
      <path
        d="M27,.88a.6.6,0,0,0-.84,0l-9.9,9.81H16.1V21.75l.13.3,8-7.87,8.1-8L27,.88"
        transform="translate(-0.18 -0.71)"
        style={{ fill: '#dfc586' }}
      />
      <path
        d="M.18,21.6a1.47,1.47,0,0,0,.44,1l6.66,6.59a.59.59,0,0,0,1-.41V14l-8-7.89H.18V21.6"
        transform="translate(-0.18 -0.71)"
        style={{ fill: '#327787' }}
      />
      <path
        d="M6.34.88a.6.6,0,0,0-.84,0L.18,6.15l8.11,8,7.94,7.87V10.69L6.34.88"
        transform="translate(-0.18 -0.71)"
        style={{ fill: '#8abb9c' }}
      />
      <path
        d="M40.29,22.67V9.4h3.55v1.78a4,4,0,0,1,3.63-2,4.07,4.07,0,0,1,3.71,2.12c1.39-1.46,2.46-2.12,4.13-2.12,3,0,4.7,1.68,4.7,4.76v8.75H56.18V15.48c0-1.85-.4-2.69-1.87-2.69S52,13.7,52,15.48v7.19H48.17V15.48c0-1.85-.4-2.69-1.86-2.69S44,13.7,44,15.48v7.19H40.29"
        transform="translate(-0.18 -0.71)"
        style={{ fill: '#132136' }}
      />
      <path
        d="M69.25,19.31a3.28,3.28,0,1,0-3.16-3.26A3.21,3.21,0,0,0,69.25,19.31Zm-5-8.18A7.1,7.1,0,0,1,74.13,11a6.89,6.89,0,0,1,2.18,5,6.75,6.75,0,0,1-2,5A6.94,6.94,0,0,1,69.23,23a6.63,6.63,0,0,1-5-2.12,6.93,6.93,0,0,1-2-4.89A6.81,6.81,0,0,1,64.25,11.13Z"
        transform="translate(-0.18 -0.71)"
        style={{ fill: '#132136' }}
      />
      <path
        d="M78.52,22.67V9.4h3.73l0,1.78a4.17,4.17,0,0,1,3.83-2c2.76,0,4.55,1.73,4.55,4.76v8.75H86.65V15.48c0-1.85-.39-2.69-1.91-2.69s-2.36.91-2.36,2.69v7.19H78.52"
        transform="translate(-0.18 -0.71)"
        style={{ fill: '#132136' }}
      />
      <path
        d="M111.46,19.31a3.28,3.28,0,1,0-3.16-3.26A3.21,3.21,0,0,0,111.46,19.31Zm-5-8.18a7.09,7.09,0,0,1,9.87-.14,6.86,6.86,0,0,1,2.19,5,6.72,6.72,0,0,1-2,5A6.91,6.91,0,0,1,111.43,23a6.63,6.63,0,0,1-5.05-2.12,6.93,6.93,0,0,1-2-4.89A6.78,6.78,0,0,1,106.46,11.13Z"
        transform="translate(-0.18 -0.71)"
        style={{ fill: '#132136' }}
      />
      <polyline
        points="92.87 21.95 92.87 19.19 98.37 12.13 92.87 12.13 92.87 8.69 102.8 8.69 102.8 11.83 97.95 18.52 102.89 18.52 102.89 21.95 92.87 21.95"
        style={{ fill: '#132136' }}
      />
    </svg>
  );
}

MonzoFull.propTypes = {
  size: PropTypes.number,
};

MonzoFull.defaultProps = {
  size: 118,
};



// WEBPACK FOOTER //
// ./src/components/icons/MonzoFull/index.js